import { render } from "./About.vue?vue&type=template&id=31d53af7&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=31d53af7&lang=scss&scoped=true"

import exportComponent from "/data/sg-h5/panther-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d53af7"]])

export default __exports__